module.exports = __webpack_public_path__ + "img/add-with-circle.d8946584.svg";